import React from "react";

const CityCenter = () => {
  // Additional images for City Center Multan
//   const additionalImages = [
//     "/images/Picture31.jpg",
//     "/images/Picture5.jpg",
//     "/images/Picture6.jpg",
//   ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">City Center Multan</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Below is a list of the project details for City Center Multan, where <strong>PACIFIC BUILDERS (PVT) LTD</strong> has executed high-standard construction work with an emphasis on precision and quality.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Construction of a high rise mall, subcontract by United Engineers (Pvt) Ltd</p>
            <p><strong>Architect:</strong> Land Mark Consultants</p>
            <p><strong>Project Description:</strong> City Center Multan is a commercial high-rise mall with modern architectural design and amenities.</p>
            <p><strong>Covered Area:</strong> 340,000 sq ft</p>
            <p><strong>Client:</strong> Dr. Tariq Khokar, IG</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture17.jpg"
            alt="City Center Multan Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {/* {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`City Center Multan ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default CityCenter;
